// @flow

import Decimal from 'decimal.js'

export const d = (n: number) => new Decimal(n)
